import { SettingsModal, SETTINGS_TABS } from "./index";
import { DocumentsPanel } from "./DocumentsPanel";

// Route element for /settings/documents.
export const DocumentsSettings = () => (
  <SettingsModal active={SETTINGS_TABS.DOCUMENTS}>
    <DocumentsPanel />
  </SettingsModal>
);
